// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__headerContainer___ENE0z {
  padding: 0;
  width: 100%;
  box-sizing: border-box;
}

.styles__titleSection___rQGw0 {
  width: calc(99.9% * 69/100 - (30px - 30px * 69/100));
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenMedium"]};
  height: 38px;
  border-radius: 3px 3px 0 0;
  display: flex;
  align-items: center;
  padding: 0 24px;
  margin-left: -20px;
}

.styles__titleSection___rQGw0:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__titleSection___rQGw0:last-child {
  margin-right: 0;
}

.styles__titleSection___rQGw0:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__titleSection___rQGw0:nth-child(100n + 1) {
  clear: both;
}

.styles__title___VSL7S {
  color: white;
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 0;
  text-transform: uppercase;
}

.styles__statusSection___hAtRd {
  width: calc(99.9% * 69/100 - (30px - 30px * 69/100));
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenVeryLight"]};
  border-radius: 0 0 3px 3px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  margin-top: 0;
  margin-left: -20px;
  position: relative;
}

.styles__statusSection___hAtRd:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__statusSection___hAtRd:last-child {
  margin-right: 0;
}

.styles__statusSection___hAtRd:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__statusSection___hAtRd:nth-child(100n + 1) {
  clear: both;
}

.styles__statusIcon___nMnzH {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenMedium"]};
  font-size: 40px;
  font-weight: bold;
}

.styles__statusContent___m4Bod {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.styles__statusLabel___mrzJg {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenMedium"]};
  font-size: 12px;
  font-weight: 400;
  margin: 0;
}

.styles__statusValue___xF_A_ {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenMedium"]};
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1;
}

.styles__templateId___xgUCY {
  position: absolute;
  font-size: 15px;
  top: 12px;
  right: 12px;
}

.styles__templateId___xgUCY span {
    font-weight: 800;
  }

.styles__lockUnlockIcon___tmWXH {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 8px;
  right: 12px;
  gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Deposit/Received/styles.css"],"names":[],"mappings":"AAIA;EAEE,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oDAAmB;EACnB,8DAA+B;EAC/B,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AATA;EACE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AAQrB;;AATA;EACE,eAAmB;AAQrB;;AATA;EACE,eAAmB;EAAnB,YAAmB;AAQrB;;AATA;EACE,WAAmB;AAQrB;;AAEA;EAEE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,oDAAmB;EACnB,8DAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAZA;EACE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AAWrB;;AAZA;EACE,eAAmB;AAWrB;;AAZA;EACE,eAAmB;EAAnB,YAAmB;AAWrB;;AAZA;EACE,WAAmB;AAWrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mDAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mDAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mDAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;AAIb;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,QAAQ;AACV","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGreenMedium, gtGreenVeryLight from colors;\n\n.headerContainer {\n  composes: content-container from helpers;\n  padding: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.titleSection {\n  lost-column: 69/100;\n  background-color: gtGreenMedium;\n  height: 38px;\n  border-radius: 3px 3px 0 0;\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  margin-left: -20px;\n}\n\n.title {\n  composes: drfTitle from helpers;\n  color: white;\n  font-size: 1.125rem;\n  font-weight: 600;\n  letter-spacing: 1px;\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.statusSection {\n  lost-column: 69/100;\n  background-color: gtGreenVeryLight;\n  border-radius: 0 0 3px 3px;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n  margin-top: 0;\n  margin-left: -20px;\n  position: relative;\n}\n\n.statusIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: gtGreenMedium;\n  font-size: 40px;\n  font-weight: bold;\n}\n\n.statusContent {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.statusLabel {\n  color: gtGreenMedium;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 0;\n}\n\n.statusValue {\n  color: gtGreenMedium;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n  line-height: 1;\n}\n\n.templateId {\n  position: absolute;\n  font-size: 15px;\n  top: 12px;\n  right: 12px;\n  span {\n    font-weight: 800;\n  }\n}\n\n.lockUnlockIcon {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  bottom: 8px;\n  right: 12px;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGreenMedium": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenMedium"]}`,
	"gtGreenVeryLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenVeryLight"]}`,
	"headerContainer": `styles__headerContainer___ENE0z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"titleSection": `styles__titleSection___rQGw0`,
	"title": `styles__title___VSL7S ${___CSS_LOADER_ICSS_IMPORT_1___.locals["drfTitle"]}`,
	"statusSection": `styles__statusSection___hAtRd`,
	"statusIcon": `styles__statusIcon___nMnzH`,
	"statusContent": `styles__statusContent___m4Bod`,
	"statusLabel": `styles__statusLabel___mrzJg`,
	"statusValue": `styles__statusValue___xF_A_`,
	"templateId": `styles__templateId___xgUCY`,
	"lockUnlockIcon": `styles__lockUnlockIcon___tmWXH`
};
export default ___CSS_LOADER_EXPORT___;
